module.exports = __webpack_public_path__ + "img/1.3c22f7e7.svg";